export const ADD_ERROR = "ADD_ERROR";
export const REMOVE_ERROR = "REMOVE_ERROR";
export const SET_CURRENT_USER = "SET_CURRENT_USER";
export const LOAD_MESSAGES = "LOAD_MESSAGES";
export const REMOVE_MESSAGE = "REMOVE_MESSAGE";
